// 回执完成情况
export enum EReceiptCompleteType {
    // [Description("申请完成")]
    Completed = 0,

    // [Description("申请延期")]
    Delayed = 1,

    // [Description("申请取消")]
    Cancelled = 2,

    // [Description("待处理")]
    None = -1
}